/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: exports a function, not a component. */
import { SCHEDULER_GRID_METRICS } from './scheduler-grid-metrics.js';

/** Events per day that fit ilamy's six equal-height week rows beside the "+N more" line. */
export function schedulerDayCapacity(gridHeight: number): number | undefined {
  if (gridHeight <= 0) return undefined;
  const {
    weekRowCount,
    weekdayHeaderHeight,
    dayNumberHeight,
    eventSlotHeight,
    moreLineHeight,
    minCapacity,
  } = SCHEDULER_GRID_METRICS;
  const rowHeight = (gridHeight - weekdayHeaderHeight) / weekRowCount;
  return Math.max(
    minCapacity,
    Math.floor((rowHeight - dayNumberHeight - moreLineHeight) / eventSlotHeight),
  );
}
